// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorStatus_error__2jwbs"};